// frontend/src/pages/portal/modifiers/modifierRules.js
//
// Small helpers shared by the three Option Groups components (the list tab,
// the group editor, and the nested-group picker) so the selection-rule
// wording and the client-generated group id stay identical everywhere.

export const isRequired = (g) => (g?.min_select || 0) > 0;

// Mirrors the copy in docs/mockups/nested-addons/portal-group-builder.html's
// ruleText() — kept here once so the card, the editor and the picker never
// drift apart on how a rule reads.
export const ruleLabel = (g, t) => {
    if (!g) return '';
    if (isRequired(g) && g.max_select === 1) return t('rule_required_pick_1', {}, 'Required · pick 1');
    if (g.max_select === 1) return t('rule_optional_pick_1', {}, 'Optional · pick 1');
    if (g.max_select) return t('rule_optional_up_to', { max: g.max_select }, `Optional · up to ${g.max_select}`);
    return t('rule_optional_pick_any', {}, 'Optional · pick any');
};

const slugify = (s) => (s || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

// Group ids are client-generated (the backend's ModifierGroupCreate schema
// requires one) — slug the name and disambiguate against every group the
// tenant already has, the same way the product-code generator in
// PortalProductsPage.js avoids collisions.
export const generateGroupId = (name, allGroups = []) => {
    const base = `g_${slugify(name) || 'group'}`;
    const existing = new Set((allGroups || []).map(g => g.group_id));
    if (!existing.has(base)) return base;
    let i = 2;
    while (existing.has(`${base}_${i}`)) i += 1;
    return `${base}_${i}`;
};
